export { MagnetTechTestsPage } from './MagnetTechTestsPage';
